import { TelegramConversionShowcase } from "@/components/telegram/TelegramConversionShowcase";

export function TelegramFeedPage() {
  return (
    <main>
      <TelegramConversionShowcase />
    </main>
  );
}
